import React from "react";
import { fmtMoney } from "../lib/api";

/**
 * Small Δ chip surfaced next to the Spend cell when the TM-attributed spend and
 * the platform-direct spend diverge by more than `threshold` percent.
 *
 * - tm: TM `/performance_data` spend (already FX-converted to GBP)
 * - platform: Meta/Google direct API spend (already FX-converted to GBP)
 * - threshold: divergence above which to show the warning (default 2)
 */
export default function SpendDeltaBadge({ tm, platform, threshold = 2, testid }) {
  const a = Number(tm) || 0;
  const b = Number(platform) || 0;
  if (a <= 0 || b <= 0) return null;
  const diff = a - b;
  const base = Math.max(a, b);
  const pct = (diff / base) * 100;
  if (Math.abs(pct) < threshold) return null;
  const sign = pct > 0 ? "+" : "";
  return (
    <span
      data-testid={testid}
      title={`TM-attributed: ${fmtMoney(a)} · Platform-direct: ${fmtMoney(b)} · ${sign}${pct.toFixed(1)}% drift`}
      className={`ml-1 px-1 py-0.5 text-[9px] font-mono uppercase tracking-wider cursor-help ${
        Math.abs(pct) >= 10 ? "bg-red-50 text-red-700"
        : Math.abs(pct) >= 5 ? "bg-amber-50 text-amber-700"
        : "bg-zinc-100 text-zinc-600"
      }`}
    >
      Δ{sign}{pct.toFixed(0)}%
    </span>
  );
}
